import { ReactNode } from 'react';
import { styled } from '@classify/react-core-components/styles';

interface Props {
  isCompact?: boolean;
  children?: ReactNode;
}

const StyledContainer = styled('div', {
  shouldForwardProp: (prop) => !['isCompact'].includes(prop as string),
})<{ isCompact?: boolean }>(({ isCompact }) => ({
  height: isCompact ? 250 : '60vh',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}));

const LoaderContainer = ({ isCompact = false, children }: Props) => (
  <StyledContainer isCompact={isCompact}>{children}</StyledContainer>
);

export default LoaderContainer;
